type Block =
  | { type: 'title'; text: string }
  | { type: 'list'; items: string[] }
  | { type: 'paragraph'; text: string }

export function buildBlocks(description: string): Block[] {
  const lines = description
    .split('\n')
    .map(l => l.trim())
    .filter(Boolean)

  const blocks: Block[] = []
  let currentList: string[] = []

  const flushList = () => {
    if (currentList.length) {
      blocks.push({ type: 'list', items: currentList })
      currentList = []
    }
  }

  lines.forEach(line => {
    if (line.endsWith(':')) {
      flushList()
      blocks.push({ type: 'title', text: line })
      return
    }

    if (line.length < 120) {
      currentList.push(line)
      return
    }

    flushList()
    blocks.push({ type: 'paragraph', text: line })
  })

  flushList()

  return blocks
}